import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { Settings } from "lucide-react";

import { TOUR_ANCHOR } from "@/components/product-tour/tourSteps";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { usePermissions } from "@/hooks/usePermissions";

export function SettingsShortcutButton(): ReactElement | null {
  const { t } = useTranslation();
  const { can } = usePermissions();

  if (!can("nav.settings")) return null;

  const label = t("nav.settings");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          asChild
          type="button"
          variant="ghost"
          size="icon"
          className="size-9 shrink-0 lg:size-12"
        >
          <NavLink to="/settings" aria-label={label} data-tour={TOUR_ANCHOR.settings}>
            <Settings className="size-[22px]" aria-hidden />
          </NavLink>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
